import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function severityClass(sev) {
  const k = (sev || "").toString().toUpperCase();
  if (k === "CRITICAL") return "sev-critical";
  if (k === "HIGH") return "sev-high";
  if (k === "MEDIUM") return "sev-medium";
  if (k === "LOW") return "sev-low";
  return "sev-default";
}

export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toISOString().slice(0, 10);
  } catch {
    return iso;
  }
}
